import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { Images } from "lucide-react";
import ImageModal from "./ImageModal";
import config from "../../config";

const ProjectsComponents = ({ category, categorySlug, projects, id = [] }) => {
  const BASE_URL = `${config.API_BASE_URL}/uploads/`;
  const overlayColors = ["bg-dark", "bg-primary", "bg-accent", "bg-deepblue"];

  const categoryIcons = {
    ai: "/assets/icones/icones-4.png",
    design: "/assets/icones/icones-2.png",
    graphic: "/assets/icones/icones-3.png",
    lab: "/assets/icones/icones-1.png",
  };

  const categoryIcon = categoryIcons[categorySlug] || null;

  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = (project, images, index = 0) => {
    setSelectedProject({ project, images, index });
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedProject(null);
    setIsModalOpen(false);
  };

  return (
    <section id={id} className="flex justify-center">
      <div className="relative w-11/12 bg-light rounded-xl py-6 overflow-hidden my-5 mx-auto">
        <div className="container mx-auto px-4 relative">
          {/* Titre */}
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-8 flex justify-center items-center gap-x-3">
            {categoryIcon && (
              <img
                src={categoryIcon}
                alt={`${category} Icon`}
                className="w-12 h-12"
              />
            )}
            {category}
          </h2>

          {projects.length > 0 ? (
            <Swiper
              modules={[Pagination, Autoplay]}
              spaceBetween={20}
              slidesPerView={1}
              breakpoints={{
                640: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              pagination={{ clickable: true }}
              autoplay={{ delay: 3000 }}
              className="relative"
            >
              {projects.map((project) => {
                const translation = project.translations?.[0] || {};
                const randomColor =
                  overlayColors[Math.floor(Math.random() * overlayColors.length)];

                const extraImages =
                  project.secondaryImages?.map((img) => `${BASE_URL}${img.imageUrl}`) || [];

                const hasExtraImages = extraImages.length > 0;
                const allImages = [`${BASE_URL}${project.imageUrl}`, ...extraImages];

                return (
                  <SwiperSlide key={project.id} className="relative">
                    <div
                      className="relative group cursor-pointer"
                      onClick={() => openModal(project, allImages)}
                    >
                      <img
                        src={`${BASE_URL}${project.imageUrl}`}
                        alt={translation.title || "Projet"}
                        className="w-full h-[450px] object-cover rounded-lg shadow-lg transition-transform duration-300"
                      />
                      <div
                        className={`${randomColor} absolute inset-0 bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center rounded-lg`}
                      >
                        <div className="text-center text-white px-4">
                          <h3 className="text-xl font-semibold">
                            {translation.title || "Sans titre"}
                          </h3>
                          <p className="mt-2">
                            {translation.description || "Aucune description disponible."}
                          </p>
                        </div>
                      </div>

                      {/* Icône galerie */}
                      {hasExtraImages && (
                        <div className="absolute bottom-4 right-4 bg-black bg-opacity-70 text-white px-2 py-1 rounded flex items-center gap-2">
                          <Images className="w-5 h-5" />
                          <span className="text-sm">{1 + extraImages.length}</span>
                        </div>
                      )}
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          ) : (
            <p className="text-center text-gray-500">Aucun projet disponible.</p>
          )}
        </div>
      </div>

      {/* Modal de visualisation d'images */}
      {isModalOpen && selectedProject && (
        <ImageModal
          images={selectedProject.images}
          onClose={closeModal}
          initialIndex={0}
          project={selectedProject.project}
        />
      )}
    </section>
  );
};

export default ProjectsComponents;
